import { Paper } from "@mui/material";
import React, { useEffect, useState } from "react";
import { handLeft, handRight, instagram, linkedin, tiktok } from "../../assets";

export default function SocialPanel({ isExpanded, togglePanel }) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [initialScroll, setInitialScroll] = useState(false);

  useEffect(() => {
    let timeout = null;

    const onScroll = () => {
      setIsScrolled(true);

      if (!initialScroll) {
        setInitialScroll(true);
      }

      clearTimeout(timeout);

      timeout = setTimeout(() => {
        setIsScrolled(false);
      }, 200);
    };

    window.addEventListener("scroll", onScroll);

    return () => {
      window.removeEventListener("scroll", onScroll);
      clearTimeout(timeout);
    };
  }, [initialScroll]);

  return (
    <Paper
      className={`panel-socmed ${
        initialScroll && (isScrolled ? "hide" : "scrolled")
      } bg-white`}
      // className={`panel-socmed ${isExpanded ? "expanded" : ""} bg-white`}
      sx={{
        padding: "5px",
        borderRadius: "5px 5px 0 0",
        boxShadow: "5px -5px rgba(0, 0, 0)",
      }}>
      <button
        className="text-panel border-bottom d-flex align-items-center gap-50"
        onClick={togglePanel}>
        <b>Social Media Kami</b>
        <img
          className="icon-socmed"
          src={handLeft}
          // src={isExpanded ? handRight : handLeft}
          alt="hand"
          width={14}
        />
      </button>
      <div className="d-flex justify-content-between p-50">
        <img
          className="icon-socmed"
          src={instagram}
          alt="instagram"
          onClick={() =>
            window.open("https://www.instagram.com/lifeatmostrans/", "_blank")
          }
        />
        <img
          className="icon-socmed"
          src={tiktok}
          alt="tiktok"
          onClick={() =>
            window.open("https://www.tiktok.com/@lifeatmostrans/", "_blank")
          }
        />
        <img
          className="icon-socmed"
          src={linkedin}
          alt="linkedin"
          onClick={() =>
            window.open("https://www.linkedin.com/company/mostrans", "_blank")
          }
        />
      </div>
    </Paper>
  );
}
